import request from '../request';

//查询_店铺信息
export const reqGetAllData = () => request({ url:'/admin/set/all', method:'get' });

//新增_店铺信息
export const reqAddData = (data) => request({ url:'/admin/set/save', method:'post', data });

//修改_店铺信息
export const reqUpdateData = (data) => request({ url:'/admin/set/update', method:'put', data });

//上传图片_店招
// export const reqUploadImage = (data) => request({ url:'/admin/upload/banner', method:'post', params:data });

//上传图片_LOGO
// export const reqUploadLogo = (data) => request({ url:'/admin/upload/banner', method:'post', params:data });

//查询_通知栏
export const reqGetNoticeData = () => request({ url:'/admin/set/notice', method:'get' });

//新增_通知栏
export const reqAddNoticeData = (data) => request({ url:'/admin/set/saveNotice', method:'post', data });

//修改_通知栏
export const reqUpdateNoticeData = (data) => request({ url:'/admin/set/updateNotice', method:'put', data });

//查询_热销榜
export const reqGetAllHotSaleData = () => request({ url:'/admin/set/hotSale/all', method:'get' });

//新增_热销榜
export const reqAddHotSaleData = (data) => request({ url:'/admin/set/hotSale/add', method:'post', data });

//删除_热销榜
export const reqDeleteData = (id) => request({ url:`/admin/set/delete/${id}`, method:'delete'});

//调整状态_热销榜
export const reqUpdateStatus = (status, id) => request({ url:`/admin/set/status/${status}/${id}`, method:'post' });
